import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ISelectOption } from '../../../../../../../../design/inputs/select/ISelectOption';
import { getAnnotationStatusText } from '../../../../../../../../modules/annotations/getAnnotationStatusText';
import { ToggleButtonsMultiSelect } from '../../../../../../../components/ToggleButtonsMultiSelect';
import { ImageAnnotationStatus } from '../../../projectDetailsImages.model';
import { FilterContent } from '../FilterContent';
import { ImageFiltersFormProps } from '../ImageFiltersForm';

export const StatusBody = observer((props: ImageFiltersFormProps): ReactElement => {
  const { t } = useTranslator();

  const handleSelectedChanged = (selected: ISelectOption<ImageAnnotationStatus>[]): void => {
    props.onSetStatuses(selected.map((x) => x.value));
  };

  const options: ISelectOption<ImageAnnotationStatus>[] = [
    ImageAnnotationStatus.NONE,
    ImageAnnotationStatus.CLARIFICATION,
    ImageAnnotationStatus.DRAFT,
    ImageAnnotationStatus.REJECTED,
    ImageAnnotationStatus.TOREVIEW,
    ImageAnnotationStatus.ACCEPTED,
  ].map((x) => ({ value: x, label: t(getAnnotationStatusText(x)) }));

  const selectedOptions = options.filter((o) => props.imageFilters.annotationStatuses.includes(o.value));

  return (
    <FilterContent>
      <ToggleButtonsMultiSelect<ISelectOption<ImageAnnotationStatus>>
        options={options}
        values={selectedOptions}
        labelField='label'
        valueField='value'
        onSelectChange={handleSelectedChanged}
      />
    </FilterContent>
  );
});
